import { render } from "./Spacing.vue?vue&type=template&id=fc9be30a"
import script from "./Spacing.vue?vue&type=script&lang=js"
export * from "./Spacing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__